import api from './axios';

export async function get_transaction_by_id(transaction_id) {
    try {
        const response = await api.get(`/transactions/${transaction_id}`);
        return response.data;
    }
    catch (err) {
        throw err;
    }
}

export async function get_transaction_by_beneficiary_id(beneficiary_id) {
    try {
        let res = await api.get(`/transactions/beneficiary/${beneficiary_id}`);
        res = res.data;
        return res;
    }
    catch (err) {
        throw err;
    }
}

export async function addTransaction(transaction) {
    try {
        const response = await api.post('/transactions/add', transaction);
        return response.data;
    }
    catch (err) {
        throw err;
    }
}

export async function update_transaction_by_id(transaction_id, updated_transaction) {
    try {
        const response = await api.put(`/transactions/update/${transaction_id}`, updated_transaction);
        return response.data;
    }
    catch (err) {
        throw err;
    }
}

export async function delete_transaction_by_id(transaction_id) {
    try {
        let response = await api.delete(`/transactions/delete/${transaction_id}`);
        response = response.data
        return response;
    }
    catch (err) {
        throw err;
    }
}

export async function delete_transactions_by_beneficiary_id(beneficiary_id) {
    try {
        let response = await api.delete(`/transactions/delete/beneficiary/${beneficiary_id}`);
        response = response.data
        return response;
    }
    catch (err) {
        throw err;
    }
}
